// extracted by mini-css-extract-plugin
export default {"root":"IconPayoutMethod_root__Kf5u2","bankIcon":"IconPayoutMethod_bankIcon__qj1XR"};